var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('item-page', _vm._b({
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: _vm.setIndex,
      expression: "setIndex"
    }],
    ref: "page",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.fields,
      callback: function ($$v) {
        _vm.fields = $$v;
      },
      expression: "fields"
    }
  }, 'item-page', {
    page: _vm.page,
    pageIndex: _vm.pageIndex
  }, false), [_vm._l(_vm.fields, function (item, index) {
    return [_c('item-node', _vm._g(_vm._b({
      key: index,
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.fields[index],
        callback: function ($$v) {
          _vm.$set(_vm.fields, index, $$v);
        },
        expression: "fields[index]"
      }
    }, 'item-node', {
      mode: _vm.mode,
      size: _vm.size
    }, false), {
      pull: _vm.pull
    }))];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }